import ApprovalTable from './Approval.gql';

export default ApprovalTable;
